/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { forwardRef, type ForwardRefExoticComponent, type RefAttributes } from 'react';

import { jsx } from '@compiled/react';

import { cssMap, cx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { THead as PTHead, type THeadProps } from '../../../ui/primitives/thead';

const styles = cssMap({
	THeadBase: {
		position: 'sticky',
		inset: token('space.0'),
		border: 'none',
		zIndex: 200,
		display: 'grid',
	},
});

export const THead: ForwardRefExoticComponent<
	Omit<THeadProps, 'ref'> & RefAttributes<HTMLTableSectionElement>
> = forwardRef<HTMLTableSectionElement, THeadProps>(({ children, xcss, ...props }, ref) => {
	return (
		<PTHead xcss={cx(styles.THeadBase, xcss)} ref={ref} {...props}>
			{children}
		</PTHead>
	);
});
